<template>
    <div>
        <div class="container-fluid">
            <div class="blue-info-holder">
                <div class="row">
                        <div class="col-6 col-md-3">
                        <div>
                            <h5>Current plan</h5>
                            <h6>Basic</h6>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div>
                            <h5>Plan start date</h5>
                            <h6>20/3/2025</h6>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div>
                            <h5>Plan expiration date</h5>
                            <h6>20/3/2026</h6>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="updateBtn">
                            <button class="btn whiteBtn">Update plan</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="countDown-holder">
                <span>
                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" fill="white"/>
                        <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" stroke="#E5E7EB" stroke-width="0.04"/>
                        <path d="M25.241 12H18.761C15.001 12 14.711 15.38 16.741 17.22L27.261 26.78C29.291 28.62 29.001 32 25.241 32H18.761C15.001 32 14.711 28.62 16.741 26.78L27.261 17.22C29.291 15.38 29.001 12 25.241 12Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <div class="plan-count">
                    <p>Current plan expires</p>
                    <h6>46 days left</h6>
                </div>
            </div>


            <div class="white-bg">
                <div class="propPlansTopHolder">
                        <div class="top-headings">
                            <h4 class="headings">Billing History</h4>
                        </div>
                    </div>

                <div class="table-holder" style="padding: 0;">
                    <div class="mb-3 col-md-4 pl-0">
                        <input type="text" class="form-control" v-model="search" placeholder="Search with title, plan type etc.">
                    </div>
                    <div class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Billing date</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Plan type</th>
                                    <th scope="col">Billed From</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- v-for="(item, index) in landlords"
                                    :key="index" -->
                                <tr>
                                    <td>09/04/2025</td>
                                    <td>200,000</td>
                                    <td>Starter</td>
                                    <td>Bank transfer</td>
                                    <td>
                                        <span  class="credit">Paid</span>
                                    </td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>  
                                <tr>
                                    <td>09/04/2025</td>
                                    <td>200,000</td>
                                    <td>Starter</td>
                                    <td>Safe</td>
                                    <td>
                                        <span class="unpaid">Free</span>
                                    </td>
                                </tr> 
                                <tr>
                                    <td>09/04/2025</td>
                                    <td>200,000</td>
                                    <td>Starter</td>
                                    <td>Bank transfer</td>
                                    <td>
                                        <span class="credit">Paid</span>
                                    </td>
                                </tr> 
                    
                            </tbody>
                        </table>
                        <!-- <div v-if="filteredTenants.length == 0" class="empty-state mt-5 mb-5">
                            <img src="../assets/icons/emptycan-state.svg" alt="empty">
                            <h5>No available data</h5>
                        </div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/styles/custom.scss';
import { Service } from "../store/service";
import Vue from "vue";
const Api = new Service();
export default {
    name: "BillingHistory",
    data() {
        return {
            loading: false,
            search: "",
        }
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>

.blue-info-holder {
    background: #0033EA;
    margin-top: 20px;
    margin-bottom: 10px;
    padding: 15px;
    text-align: left;
    color: #ffffff;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
        color: #ffffff;
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
    }
}
.updateBtn {
    text-align: right;
}

.countDown-holder {
    background: #F5E1C8;
    padding: 15px;
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 15px;
}
.plan-count {
    p {
        font-family: Lato;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #1A1A1A;
        margin-bottom: 3px;
        text-align: left;
    }
    h6 {
        background: #ffffff;
        padding: 4px 10px;
        font-family: Lato;
        font-weight: 700;
        font-size: 24px;
        color: #00155F;
        width: fit-content;
    }
}

@media only screen and (max-width: 599px) {
    .updateBtn {
    text-align: center;
    margin-top: 30px;
}
}
</style>